import Joyride, { CallBackProps, type Props, Step } from 'react-joyride'

import { JoyrideLocale } from 'shared/ui/joyride-tour/types.ts'

import { JoyrideTooltip } from './components'

export interface JoyrideTourProps {
  steps: Step[]
  run: boolean
  onCallback: (data: CallBackProps) => void
  locale?: JoyrideLocale
  styles?: Props['styles']
}

export const JoyrideTour = ({
  steps,
  run,
  onCallback,
  locale,
  styles,
}: JoyrideTourProps) => {
  return (
    <Joyride
      steps={steps}
      run={run}
      continuous={true}
      showProgress={true}
      showSkipButton={false}
      hideCloseButton={true}
      callback={onCallback}
      tooltipComponent={JoyrideTooltip}
      locale={locale}
      styles={styles}
      floaterProps={{
        hideArrow: true,
      }}
    />
  )
}
